export default __webpack_public_path__ + "static/media/SENAIT_NL_EPILOG2.2f9e70a3.mp3";